import { render, staticRenderFns } from "./FinalThoughts.vue?vue&type=template&id=0499c1be&scoped=true&"
import script from "./FinalThoughts.vue?vue&type=script&lang=js&"
export * from "./FinalThoughts.vue?vue&type=script&lang=js&"
import style0 from "./FinalThoughts.vue?vue&type=style&index=0&id=0499c1be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0499c1be",
  null
  
)

export default component.exports